import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Fieldset from '@/components-latest/layout/Fieldset'
import Separator from '@/components-latest/primitives/Separator'
import FiltersDrawer from '@/components-latest/shared/FiltersDrawer'
import {
  Form,
  GroupCheckboxField,
  GroupToggleField
} from '@/components-latest/shared/Form'
import { useMenuFilterForm } from '@/components-latest/ui/MenuPage/MenuFilter/useMenuFilterForm'
import Styles from './MenuFilter.module.scss'
import { selectSelectedBranchId } from '@/ducks/store/selectors/store.selectors'
import { useSelector } from 'react-redux'

interface IOrdersFilterProps {
  children: React.ReactNode
 
}

const MenuFilter: React.FC<IOrdersFilterProps> = ({ children }) => {
  const { t } = useTranslation()
  const [shouldResetForm, setShouldResetForm] = useState(false)
  const selectedBranchId = useSelector(selectSelectedBranchId);
  const { onReset, onSubmit, shouldDisableSubmit, form, mainCategories } =
  useMenuFilterForm(shouldResetForm,selectedBranchId )
  return (
    <FiltersDrawer
      onOpenChange={isOpen => setShouldResetForm(isOpen)}
      onReset={onReset}
      onSubmit={onSubmit}
      disabled={shouldDisableSubmit}
      trigger={children}
      data-testid="menu-filters-drawer">
      <Form {...form}>
        <form className={Styles.form} onSubmit={onSubmit}>
          <Fieldset label={t('menu.filters.fieldset.availability')}>
            <div className={Styles.equalColumns}>
              <GroupToggleField
                name="status"
                value="all"
                label={t('menu.filters.status.all')}
                control={form.control}
              />
              <GroupToggleField
                name="status"
                value="unavailable"
                label={t('menu.filters.status.unavailable')}
                control={form.control}
              />
              <GroupToggleField
                name="status"
                value="available"
                label={t('menu.filters.status.available')}
                control={form.control}
              />
              <Separator />
            </div>
          </Fieldset>

          <Fieldset label={t('menu.filters.fieldset.category')}> 
            {mainCategories.map(category => (
              <GroupCheckboxField
                key={category.id}
                control={form.control}
                name="mainCategories"
                value={category.id}
                label={category.name}
              />
            ))}
          </Fieldset>
        </form>
      </Form>
    </FiltersDrawer>
  )
}

export default MenuFilter
